import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReminderAnticlockwise = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.22566 3.07764C3.95233 4.12273 3.81573 5.19843 3.81895 6.2778C3.81979 6.55966 4.05559 6.6508 4.28529 6.70164L4.28709 6.70204M7.3364 6.99214C6.31132 7.02083 5.2872 6.92325 4.28709 6.70204M4.28709 6.70204C5.28689 5.11579 6.94632 3.95835 8.94637 3.6604C12.5881 3.11789 15.9801 5.63028 16.5226 9.27199C17.0651 12.9137 14.5527 16.3057 10.911 16.8482C7.40033 17.3712 4.12175 15.0552 3.4043 11.6253M11.667 12.4998L10.2445 11.0773C10.0882 10.921 10.0004 10.709 10.0004 10.488V7.49984",
		stroke: "#3F3F46",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgReminderAnticlockwise);
export default ForwardRef;
